"use client";

import React from "react";
import Link from "next/link";
import { NewButton } from "@/components/ui/NewButton";
import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";

const registerUrl = "https://console.pickcel.com/auth/register";

export function HomeHeroButtons() {
  const isAdLanding = useIsAdLanding();

  if (isAdLanding) {
    return (
      <div className="flex flex-col items-center md:flex-row gap-6 justify-center md:items-start lg:justify-start">
        <Link
          href="/book-a-demo"
          target="_self"
          data-mixpanel-id="hero-contact-us-utm"
        >
          <NewButton
            variant="primary"
            size="md"
            arrow="grow"
            asChild
          >
            Book a Demo
          </NewButton>
        </Link>
        <Link href="/company/contact" target="_self" data-mixpanel-id="hero-book-a-demo-utm">
          <NewButton
            variant="outlinePrimary"
            size="md"
            asChild
          >
            Contact Us
          </NewButton>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center md:flex-row gap-6 justify-center md:items-start lg:justify-start">
    <Link href="/book-a-demo" target="_self" data-mixpanel-id="hero-book-a-demo">
      <NewButton
        className="w-48"
        variant="primary"
        size="lg"
        arrow="grow"
        asChild
      >
        Book a Demo
      </NewButton>
    </Link>
      <Link
        href={registerUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-mixpanel-id="hero-start-free-trial"
      >
        <NewButton
          variant="outlinePrimary"
          size="lg"
          className="w-52"
          disclaimer="No credit card required"
          disclaimerTextColor="text-white"
          arrow="hover"
          arrowColorClass="stroke-primary"
          asChild
        >
          Start Free Trial
        </NewButton>
      </Link>
    </div>
  );
}
